import { useEffect } from "react";

import { cn } from "@/lib/cn";

export type ToastMessage = { id: number; text: string; undo?: () => void };

/**
 * Aviso corto con «Deshacer», abajo y sin tapar nada: se deshace en vez de preguntar «¿seguro?».
 * Se va solo a los 8 s. Lo usan Labs (con su propio estilo, `className`) y el Cotizador al guardar el
 * formato o el tipo por defecto de un diseño.
 */
export function Toast({ message, onDone, className }: { message: ToastMessage; onDone: () => void; className?: string }) {
  useEffect(() => {
    const timer = setTimeout(onDone, 8000);
    return () => clearTimeout(timer);
  }, [message.id, onDone]);
  return <div role="status" className={className ?? cn(
    "fixed bottom-6 left-1/2 z-50 flex max-w-[min(640px,92vw)] -translate-x-1/2 items-center gap-3",
    "rounded-lg bg-surface px-3.5 py-2.5 text-sm text-ink shadow-soft",
  )}>
    <span>{message.text}</span>
    {message.undo && <button type="button" className={className ? undefined : "font-semibold underline"} onClick={() => { message.undo?.(); onDone(); }}>Deshacer</button>}
  </div>;
}
